import { pushDataLayerCobasi } from "./dataLayer";
import { buildCurrentPageData, getAnalyticsUserData } from "./helpers";

import type { PageviewPayload } from "./types";

export {
  getAnalyticsEnvironment,
  getAnalyticsUserData,
  normalizePagePath
} from "./helpers";

export const buildPageviewPayload = (path: string): PageviewPayload => {
  return {
    event: "pageview",
    page_data: buildCurrentPageData(path),
    user_data: getAnalyticsUserData()
  };
};

export const pushPageviewDataLayer = (path: string): void => {
  pushDataLayerCobasi(
    { page_data: null, user_data: null },
    buildPageviewPayload(path)
  );
};
